<template>
  <div>
    <!-- Mobile: Select Menu -->
    <div class="hidden-sm-and-up">
      <v-select
        :items="items"
        label="Settings"
        item-text="title"
        outlined
        dense
        outlined
      >
        <template v-slot:item="{ item }">
          <v-list-item
            :key="item.name"
            :to="!item.path ? { name: item.name } : { path: item.path }"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            link
          >
            <v-list-item-icon v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>

            <v-chip
              v-if="item.badge"
              :color="item.color || 'primary'"
              small
              class="white--text"
              label
            >
              {{ item.badge }}
            </v-chip>
          </v-list-item>
        </template>
      </v-select>
    </div>

    <!-- Desktop: Sidebar Nav -->
    <div class="hidden-xs-only">
      <v-navigation-drawer stateless permanent class="elevation-0" width="260">
        <v-list dense nav>
          <template v-for="item in items">
            <!-- Header -->
            <v-subheader v-if="item.header" class="grey--text text--darken-1">
              {{ item.header }}
            </v-subheader>

            <!-- Divider -->
            <v-divider v-else-if="item.divider" class="my-2" />

            <!-- Group -->
            <v-list-group
              :key="item.name || item.header"
              v-else-if="item.items"
              no-action
              prepend-icon
              :value="false"
            >
              <template v-slot:activator>
                <v-list-item-title>
                  <v-icon small left class="mr-2">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </template>

              <v-list-item
                v-for="(subItem, i) in item.items"
                :key="i"
                :to="
                  !subItem.path
                    ? { name: subItem.name }
                    : { path: subItem.path }
                "
                :disabled="subItem.disabled"
                :target="subItem.target"
                rel="noopener"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
                <v-chip
                  v-if="subItem.badge"
                  small
                  label
                  class="white--text"
                  :color="subItem.color || 'primary'"
                >
                  {{ subItem.badge }}
                </v-chip>
              </v-list-item>
            </v-list-group>

            <!-- Single Link -->
            <v-list-item
              v-else
              :to="!item.path ? { name: item.name } : { path: item.path }"
              :disabled="item.disabled"
              :target="item.target"
              rel="noopener"
              link
            >
              <v-list-item-icon v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
              <v-chip
                v-if="item.badge"
                small
                label
                class="white--text"
                :color="item.color || 'primary'"
              >
                {{ item.badge }}
              </v-chip>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: "settings-navbar",
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.loadNav();
  },
  methods: {
    loadNav() {
      this.items = [
        { header: this.$t("sideBar.setting") },
        {
          title: this.$t("sideBar.general"),
          icon: "mdi-home",
          name: "General",
          path: "/settings/general",
        },
        {
          title: "Users",
          icon: "mdi-account",
          name: "User",
          path: "/settings/user",
        },
        {
          title: this.$t("sideBar.billing"),
          icon: "mdi-coin",
          name: this.$t("sideBar.billing"),
          path: "/settings/billing",
        },
      ];
    },
  },
};
</script>